import { useTheme } from '@mui/material/styles';
import { AnimatePresence } from 'framer-motion';
import { useToastContext } from '../context/ToastContext';
import Toast from './Toast';

export default function ToastContainer() {
    const theme = useTheme();
    const { toasts, removeToast } = useToastContext();

    return (
        <div style={theme.toastContainer}>
            <AnimatePresence>
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        id={toast.id}
                        message={toast.message}
                        type={toast.type}
                        onClose={removeToast}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
}
